import { getCurrencyCookie } from "shared/utils/cookies";

export const formatCurrency = (val, currency = getCurrencyCookie()) =>
  val.toLocaleString(undefined, {
    style: "currency",
    currency,
  });
